import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import BackgroundLayer from './BackgroundLayer'

class PoweredBy extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    const { classes, ...rest } = this.props

    return (
      <BackgroundLayer className={classes.poweredBy} {...rest}>
        <p className={classes.text}>Powered by DimOrder</p>
      </BackgroundLayer>
    )
  }
}

const styles = {
  poweredBy: {
    marginBottom: 16,
  },
  text: {
    fontSize: 14,
    fontWeight: 300,
    letterSpacing: '0.075em',
    color: '#ffffff',
    textAlign: 'center',
    margin: 0,
  },
}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(PoweredBy)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/PoweredBy.jsx